export default "__VITE_ASSET__935F578W__ 224w, __VITE_ASSET__DCYzST8R__ 448w";